<script lang="ts">
  export let salesRepNames: string[];
  export let accountNumber: string;
  export let distributorAccount: {
    city: string;
    state: string;
    zip: string;
    address1: string;
    address2: string;
    address3: string;
  };

  const formattedSalesRepNames = salesRepNames?.join(", ");

  const buildCityStateZipString = () => {
    const cityStateZipArray = [
      distributorAccount.city,
      distributorAccount.state,
      distributorAccount.zip,
    ];
    const cityStateZipArrayWithoutEmptyValues = cityStateZipArray.filter(Boolean);
    return cityStateZipArrayWithoutEmptyValues.join(", ");
  };
  const cityStateZipString = buildCityStateZipString();

  const buildAddressLines = () => {
    const addressLineArray = [
      distributorAccount.address1,
      distributorAccount.address2,
      distributorAccount.address3,
    ];
    const addressLinesWithoutEmptyValues = addressLineArray.filter(Boolean);
    return addressLinesWithoutEmptyValues;
  };
  const addressLines = buildAddressLines();

</script>

<div data-testid="account-details">
  <span class="fizz-text-strong">Account number:</span>
  <span>#{accountNumber}</span>
</div>
{#if formattedSalesRepNames}
  <div data-testid="sales-reps">
    <span class="fizz-text-strong">Sales reps:</span>
    <span>{formattedSalesRepNames}</span>
  </div>
{/if}
<div>
  <p class="fizz-text-strong">Your business address:</p>
  {#each addressLines as addressLine, index}
    <p data-testid={`address-${index}`}>{addressLine}</p>
  {/each}
  <p>{cityStateZipString}</p>
</div>
